<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import { QuillEditor } from '@vueup/vue-quill'

import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  components: {
    Layout,
    PageHeader,
    QuillEditor
  },
  data() {
    var vm = this;

    return {
      editorConfig: {
        theme: 'snow',
        placeholder: vm.$t('email_template.placeholder.body'),
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }]
          ]
        }
      },

      tags: [],
      data: {},
    };
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  methods: {
    load() {
      var vm = this;

      vm.create();
      vm.loadTags();
      vm.newData();
    },
    newData() {
      var vm = this;

      var data = {
        category_id: null,
        subject: null,
        body: null
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('config_email_template_create');
      try {
        vm.newData();

        var resp = await this.$api.EmailTemplate.get(this.$route.params.id);
        var data = resp.data.data;

        vm.data = data;

        this.$loading.off('config_email_template_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async submit() {
      var vm = this;
      this.$loading.on('config_email_template_submit');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.EmailTemplate.create(postData);

        var data = resp.data;

        vm.create();

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('config_email_template_submit');
    },
    _createPostData: function (data) {

      return data;
    },

    async simulate() {
      var vm = this;
      this.$loading.on('config_email_template_simulate');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.EmailTemplate.simulate(postData);

        var data = resp.data;

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('config_email_template_simulate');
    },

    //============

    async loadTags() {
      var vm = this;

      vm.$loading.on('config_email_template_tags_create');

      try {
        var resp = await this.$api.EmailTemplate.tags(this.$route.params.id);

        var tags = resp.data.data;
        vm.tags = tags;

        vm.$loading.off('tags_load');
      } catch (err) {
        // console.log(err.response.data.message)
      }
      this.$loading.off('config_email_template_tags_create');
    },

    fetchCategory: async function (params) {
      var newParams = {
        ...params,
        group_by: 'email_template',
        page: 'all'
      };

      const resp = await this.$api.Category.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },

    copy(tr) {
      var vm = this;

      var selected = vm.$_.find(vm.tags, { tag: tr.tag });

      var value = selected.tag;

      const el = document.createElement('textarea');
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      vm.$flash.success(vm.$t('email_template.alert.copy'));
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('email_template.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <BRow>
      <BCol lg="8">
        <b-form @submit="submit()">
          <BCard no-body>
            <BCardBody>
              <loading :loading="$loading.get('config_email_template_create')" variant="dark" type="block">
                <BRow>
                  <BCol class="mb-3" lg="12">
                    <label for="choices-publish-status-input" class="form-label">{{ $t('email_template.label.category')
                      }}</label>
                    <dynamic-select v-model="data.category_id" :placeholder="$t('email_template.placeholder.category')"
                      :loadOptions="fetchCategory" />
                  </BCol>
                  <BCol class="mb-3" lg="12">
                    <label class="form-label" for="product-title-input">{{ $t('email_template.label.subject')
                      }}</label>
                    <input type="text" class="form-control" v-model="data.subject" id="product-title-input"
                      :placeholder="$t('email_template.placeholder.subject')"
                      :disabled="$loading.get('config_email_template_create')" />
                  </BCol>
                  <BCol class="mb-3" lg="12">
                    <label class="form-label" for="product-title-input">{{ $t('email_template.label.body')
                      }}</label>
                    <div class="ckeditor-classic">
                      <QuillEditor v-model:content="data.body" :options="editorConfig" :is-semantic-html-model="true"
                        contentType="html" />
                    </div>
                  </BCol>
                  <BCol lg="12">
                    <div class="hstack gap-2 justify-content-end">
                      <BButton type="button" variant="primary" class="w-sm" @click="simulate"
                        v-if="$ac.hasAccess('config_email_template_create')"
                        :disabled="$loading.get('config_email_template_simulate')">
                        <loading :loading="$loading.get('config_email_template_simulate')" variant="light"
                          type="button">
                          <i class="mdi mdi-email-open-multiple-outline me-1"></i>
                          {{ $t('basic.btn.simulate') }}
                        </loading>
                      </BButton>
                      <BButton type="submit" variant="success" class="w-sm"
                        v-if="$ac.hasAccess('config_email_template_create')"
                        :disabled="$loading.get('config_email_template_submit')">
                        <loading :loading="$loading.get('config_email_template_submit')" variant="light" type="button">
                          <i class="mdi mdi-floppy me-1"></i>
                          {{ $t('basic.btn.save') }}
                        </loading>
                      </BButton>
                    </div>
                  </BCol>
                </BRow>
              </loading>
            </BCardBody>
          </BCard>
        </b-form>
      </BCol>
      <BCol lg="4">
        <BCard no-body>
          <BCardBody>
            <loading :loading="$loading.get('config_email_template_tags_create')" variant="dark" type="block">
              <div class="table-responsive table-card position-relative">
                <table class="table align-middle table-hover table-nowrap mb-0">
                  <thead class="table-light">
                    <tr>
                      <th v-if="$ac.hasAccess('config_email_template_create')" style="width: 50px;">{{ $t('basic.label.action') }}</th>
                      <th>{{ $t('email_template.label.tags') }}</th>
                      <th>{{ $t('email_template.label.notes') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tr, index) in tags" :key="index">
                      <td v-if="$ac.hasAccess('config_email_template_create')">
                        <ul class="list-inline hstack gap-2 mb-0">
                          <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover"
                            data-bs-placement="top" :title="$t('email_template.btn.copy')">
                            <BLink variant="primary" class="d-inline-block" @click.prevent="copy(tr)">
                              <i class="mdi mdi-content-copy fs-16"></i>
                            </BLink>
                          </li>
                        </ul>
                      </td>
                      <td><b>{{ tr.tag }}</b></td>
                      <td>{{ tr.notes }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </loading>
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>
  </Layout>
</template>